export default function () {

    function selectYourChooChoo() {

        const $choochoos = $(".choochoo");
        const $selectedValueInput = $("#selectedValue");

        $choochoos.on("click", function () {
            // Toggle background color for selected option
            $choochoos.removeClass("active");
            $(this).addClass("active");

            // Update the hidden form field with the selected value
            const selectedValue = $(this).data("value");
            $selectedValueInput.val(selectedValue);
        });

        const $form = $("#eventForm");
        $form.on("submit", function (event) {
            if (!$form[0].checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            }

            $form.addClass("was-validated");
        });
    }

    selectYourChooChoo();
}
